(function ($, Cobalt, undefined) {
    Cobalt.CPAdvertising =
    {
        initialize: function () {
            Cobalt.runOnHtmlInsert(function () {
                Cobalt.CPAdvertising.attachTargetChange();
                $("form.j-target-form").each(Cobalt.CPAdvertising.bindTargetForm);
                Cobalt.CPAdvertising.bindRemove();

            });
        },
        attachTargetChange: function () {
            $("#ad-target-form").on("change", "select.j-target-type", function () {
                var $selectElem = $(this);
                var val = $selectElem.val();
                var $parent = $("#ad-target-form");
                if (val == 1) {
                    $parent.find("#form-field-url-pattern").hide();
                    $parent.find("#form-field-controller-name").show();
                    $parent.find("#form-field-controller-action").show();
                }
                else if (val == 2) {
                    $parent.find("#form-field-controller-name").hide();
                    $parent.find("#form-field-controller-action").hide();
                    $parent.find("#form-field-url-pattern").show();
                }
            });
            $("#ad-target-form").find("select.j-target-type").change();

        },

        bindTargetForm: function () {

            var $form = $(this);
            $form.ajaxForm(
        {

            success: function (data, textStatus, xhr) {
                switch (data.Status) {

                    case "success":
                        var $newTarget = $(data.html);
                        Cobalt.triggerHtmlInsert($newTarget);

                        // Remove the no-results message, if one exists
                        $("ul.advertising-target-listing > li.no-results").remove();

                        if ($form.hasClass("j-target-edit-form")) {
                            var $existingTarget = $("div.j-target." + data.targetID);
                            $existingTarget.find("div.j-target-content").html($newTarget.find("div.j-target-content").html());

                        }
                        else {
                            $("ul.advertising-target-listing").append($newTarget);
                        }
                        Cobalt.Forms.bindModalLinks($(".advertising-target-listing")); //rebind modal
                        $(".ui-dialog-titlebar-close").click();

                        break;
                    case "invalid":
                        Cobalt.Forms.displayErrors($form, data.Errors);
                    default:
                        throw "Unknown data result from target form: " + data.Status;
                }
            },
            dataType: "json"
        });
        },
        bindRemove: function () {
            $("ul.advertising-target-listing").on("deleteConfirmPost", ".j-target-content .remove-link", function () {
                var $link = $(this);
                var $listing = $link.closest(".ad-target-item");
                $link.closest(".ad-target-item").remove();

                Cobalt.triggerHtmlInsert($("ul.advertising-target-listing"));
            });
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.CPAdvertising.js